// src/providers/statProvider.ts
import { DataProvider } from "react-admin";
import { appConfig } from "@/commons";
import {
  HistoryVoucherType,
  RankingType,
  StatsOverviewType,
  StatsOverviewVoucherType,
} from "@/types";
import { httpClient } from "@/utilities";

const apiUrl = appConfig.api.baseUrl;

export type StatProvider = Partial<DataProvider> & {
  getStatsOverview?: () => Promise<{ data: StatsOverviewType }>;
  getStatsOverviewVoucher?: () => Promise<{ data: StatsOverviewVoucherType }>;
  getHistoryVoucher?: () => Promise<{ data: HistoryVoucherType[] }>;
  getRanking?: (type: "day" | "week") => Promise<{ data: RankingType[] }>;
};

const statProvider: StatProvider = {
  async getStatsOverview() {
    const { json } = await httpClient(`${apiUrl}/stats/overview`);
    if (!json) throw new Error("Invalid API response: No data");
    return { data: { id: "overview", ...json } };
  },

  async getStatsOverviewVoucher() {
    const { json } = await httpClient(`${apiUrl}/stats/overviewvoucher`);
    if (!json) throw new Error("Invalid API response: No data");
    return { data: { id: "overviewvoucher", ...json } };
  },

  async getHistoryVoucher() {
    const { json } = await httpClient(`${apiUrl}/stats/historyvoucher`);
    if (!json) throw new Error("Invalid API response: No data");
    return { data: json as HistoryVoucherType[] };
  },
  async getRanking(type: "day" | "week") {
    const uri = type === "day" ? "rankingday" : "rankingweek";
    const { json } = await httpClient(`${apiUrl}/stats/${uri}`);
    if (!json) throw new Error("Invalid API response: No data");
    return { data: json as RankingType[] };
  },
};

export default statProvider;
